var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackward = function SvgBackward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/backward"
  }, /*#__PURE__*/React.createElement("g", {
    id: "backward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M51.3334 19.96V37.04C51.3334 40.54 47.5301 42.7334 44.4968 40.9834L37.1001 36.7367L29.7034 32.4667C29.2368 32.1867 28.8634 31.8834 28.5601 31.51V25.5367C28.8634 25.1634 29.2368 24.86 29.7034 24.58L37.1001 20.31L44.4968 16.0634C47.5301 14.2667 51.3334 16.46 51.3334 19.96Z",
    stroke: "#0C9BED",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.5598 19.96V37.04C28.5598 40.54 24.7564 42.7334 21.7231 40.9834L14.3265 36.7367L6.92979 32.4667C3.89645 30.7167 3.89645 26.3534 6.92979 24.58L14.3265 20.31L21.7231 16.0634C24.7564 14.2667 28.5598 16.46 28.5598 19.96Z",
    stroke: "#0C9BED",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backward.4bbbbb01.svg";
export { ForwardRef as ReactComponent };